import { useState } from 'react';
import * as React from 'react';
import gettext from '@sdk/lang/gettext';

import SurveyCommentStep from '../survey/SurveyCommentStep';
import SurveyFinishStep from '../survey/SurveyFinishStep';
import { SurveyCommentStepType, SurveyFinishStepType } from '../survey/types/';

enum NpsSteps {
  comment1 = 2,
  comment2 = 3,
  finish = 4,
}

const STEPS_CONFIG = {
  [NpsSteps.comment1]: {
    text: gettext('How did you learn about Sling? '),
    submitLabel: gettext('Next'),
    number: 1,
  } as SurveyCommentStepType,
  [NpsSteps.comment2]: {
    text: gettext(
      'Which channels do you find useful when searching for work software for your industry?'
    ),
    number: 2,
  } as SurveyCommentStepType,
  [NpsSteps.finish]: {
    title: gettext('Thank you for your participation! '),
  } as SurveyFinishStepType,
};

const STEPS_COUNT = 2;

type Props = {
  comment1: string;
  setComment1: (comment: string) => void;
  comment2: string;
  setComment2: (comment: string) => void;
  submitForm: () => void;
  closeSurvey: () => void;
};

const AfterSignupSurveySteps: React.FC<React.PropsWithChildren<Props>> = ({
  comment1,
  setComment1,
  comment2,
  setComment2,
  submitForm,
  closeSurvey,
}) => {
  const [step, setStep] = useState(NpsSteps.comment1);

  const nextStep = (): void => {
    setStep((step) => {
      const next = step + 1;

      if (next === NpsSteps.finish) {
        submitForm();
      }

      return step + 1;
    });
  };

  if (step === NpsSteps.comment1) {
    const currentStep = STEPS_CONFIG[NpsSteps.comment1];
    return (
      <SurveyCommentStep
        comment={comment1}
        setComment={setComment1}
        submitStep={nextStep}
        stepsCount={STEPS_COUNT}
        stepNumber={currentStep.number}
        text={gettext(currentStep.text)}
        submitLabel={gettext(currentStep.submitLabel)}
      />
    );
  }

  if (step === NpsSteps.comment2) {
    const currentStep = STEPS_CONFIG[NpsSteps.comment2];
    return (
      <SurveyCommentStep
        comment={comment2}
        setComment={setComment2}
        submitStep={nextStep}
        stepsCount={STEPS_COUNT}
        stepNumber={currentStep.number}
        text={gettext(currentStep.text)}
      />
    );
  }

  if (step === NpsSteps.finish) {
    const currentStep = STEPS_CONFIG[NpsSteps.finish];
    return (
      <SurveyFinishStep
        title={gettext(currentStep.title)}
        subtitle={gettext(currentStep.subtitle)}
        closeSurvey={closeSurvey}
      />
    );
  }

  return null;
};

export default AfterSignupSurveySteps;
